"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamPartIDUtils = void 0;
exports.toStreamPartID = toStreamPartID;
const StreamID_1 = require("./StreamID");
const partition_1 = require("./partition");
const DELIMITER = '#';
function toStreamPartID(streamId, streamPartition) {
    (0, partition_1.ensureValidStreamPartitionIndex)(streamPartition);
    return `${streamId}${DELIMITER}${streamPartition}`;
}
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class StreamPartIDUtils {
    static parse(streamPartIdAsStr) {
        const [streamId, streamPartition] = StreamPartIDUtils.parseRawElements(streamPartIdAsStr);
        if (streamPartition === undefined) {
            throw new Error(`invalid streamPartId string: ${streamPartIdAsStr}`);
        }
        (0, StreamID_1.toStreamID)(streamId); // throws if not valid
        (0, partition_1.ensureValidStreamPartitionIndex)(streamPartition);
        return streamPartIdAsStr;
    }
    static getStreamID(streamPartId) {
        return this.getStreamIDAndPartition(streamPartId)[0];
    }
    static getStreamPartition(streamPartId) {
        return this.getStreamIDAndPartition(streamPartId)[1];
    }
    static getStreamIDAndPartition(streamPartId) {
        return StreamPartIDUtils.parseRawElements(streamPartId);
    }
    static parseRawElements(str) {
        const lastIdx = str.lastIndexOf(DELIMITER);
        if (lastIdx === -1 || lastIdx === str.length - 1) {
            return [str, undefined];
        }
        return [str.substring(0, lastIdx), Number(str.substring(lastIdx + 1))];
    }
}
exports.StreamPartIDUtils = StreamPartIDUtils;
//# sourceMappingURL=StreamPartID.js.map